import { Phone, Mail } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

interface ContactButtonsProps {
  variant?: "light" | "dark";
  showLabels?: boolean;
  className?: string;
}

const ContactButtons = ({ variant = "light", showLabels = true, className = "" }: ContactButtonsProps) => {
  const baseStyles = variant === "light" 
    ? "bg-white text-secondary hover:bg-cream border border-secondary/10" 
    : "bg-secondary text-cream hover:bg-secondary/90";

  return (
    <div className={`flex flex-wrap gap-3 justify-center ${className}`}>
      <a
        href="tel:+447702696253"
        className={`flex items-center gap-2 px-5 py-3 rounded-md font-medium transition-all ${baseStyles}`}
      >
        <Phone className="w-4 h-4" />
        {showLabels && <span>Call</span>}
      </a>
      <a
        href="mailto:hello@oliviaflemming.co.uk"
        className={`flex items-center gap-2 px-5 py-3 rounded-md font-medium transition-all ${baseStyles}`}
      >
        <Mail className="w-4 h-4" />
        {showLabels && <span>Email</span>}
      </a>
      <a
        href="https://wa.me/447702696253"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 px-5 py-3 rounded-md font-medium bg-green-600 text-white hover:bg-green-700 transition-all"
      >
        <FaWhatsapp className="w-4 h-4" />
        {showLabels && <span>WhatsApp</span>}
      </a>
    </div>
  );
};

export default ContactButtons;
